import { NgModule } from '@angular/core'
import { CONFIG_INITIALIZER } from '@spartacus/core'
import { CustomStoreContextConfigInitializer } from './config/custom-store-context-config-initializer'
import { StoreContextConfig } from './store-context-config'
import { CommonModule } from '@angular/common'

export const BASE_STORE_CONTEXT_ID = 'sites'

export function initSiteContextConfig (configInitializer: CustomStoreContextConfigInitializer,
                                      config: StoreContextConfig,
) {
  /**
   * Load config for `context` from backend only when there is no static config for `context.baseSite`
   */
  if (!config.mbcomstore || !config.mbcomstore[BASE_STORE_CONTEXT_ID]) {
    return configInitializer
  }
  return configInitializer
}

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: CONFIG_INITIALIZER,
      useFactory: initSiteContextConfig,
      deps: [
        CustomStoreContextConfigInitializer,
        StoreContextConfig,
      ],
      multi: true,
    }
  ],
})
export class StoreContextModule {
}
